import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { applyPhoneMask, onlyDigits } from '../../formatters/crm-phone-mask';

type Props = Omit<OutlinedInputProps, 'name' | 'value' | 'onChange'> & {
    name: string;
};

/// O formulário guarda só dígitos e o campo exibe mascarado; o backend normaliza para E.164.
export const CrmPhoneField = ({ name, ...props }: Props) => {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <OutlinedInput
                    {...props}
                    value={applyPhoneMask(field.value ?? '')}
                    onChange={(event) => field.onChange(onlyDigits(event.target.value))}
                    onBlur={field.onBlur}
                    inputProps={{ inputMode: 'tel', maxLength: 16 }}
                />
            )}
        />
    );
};
